<style>
  @media print {
    @page {
      size: 80mm auto;
      margin: 0;
    }
    .closing-print {
      background: #fff !important;
      padding: 0 !important;
      min-height: 0 !important;
      display: block !important;
    }
    .closing-print .receipt {
      width: 80mm !important;
    }
  }

  .closing-print {
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 48px 16px;
    background: #e4e2e0;
  }

  .closing-print .receipt {
    width: 300px;
  }

  .closing-print .tickets-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 11px;
  }

  .closing-print .tickets-table th,
  .closing-print .tickets-table td {
    padding: 1px 0;
    vertical-align: top;
  }

  .closing-print .tickets-table th {
    text-align: left;
    border-bottom: 1px dashed #999;
  }

  .closing-print .tickets-table .num {
    text-align: right;
    white-space: nowrap;
  }

  .closing-print .tickets-table .mix td {
    font-size: 10px;
    padding-left: 8px;
  }
</style>

<div class="closing-print">

  @if(error){
  <p>No se ha podido cargar el cierre de caja.</p>
  }

  @if(closing){
  <div class="receipt">
    <app-ticket-paper [company]="company">
      <div style="text-align: center; font-weight: 700;">CIERRE DE CAJA</div>
      @if(closing.office?.name){ <div>{{ closing.office.name }}</div> }
      <div>Desde {{ closing.period_start | date:'dd/MM/yyyy HH:mm' }}</div>
      <div>Hasta {{ closing.period_end | date:'dd/MM/yyyy HH:mm' }}</div>
      @if(closing.user?.name){ <div>Usuario: {{ closing.user.name }}</div> }

      <div class="hr"></div>

      @if(tickets.length){
      <table class="tickets-table">
        <thead>
          <tr>
            <th>Nº</th>
            <th>Pago</th>
            <th class="num">Subtotal</th>
            <th class="num">Total</th>
          </tr>
        </thead>
        <tbody>
          @for (ticket of tickets; track ticket.id) {
          <tr>
            <td>{{ ticket.id_by_company?.toString().padStart(4, '0') }}</td>
            <td>{{ paymentLabel(ticket.payment_method) }}</td>
            <td class="num" [centToEurDisplay]="ticket.subtotal"></td>
            <td class="num" [centToEurDisplay]="ticket.total"></td>
          </tr>
          @if(ticket.payment_method === 'mixto'){
          @for (mix of ticket.mix_pay || []; track $index) {
          <tr class="mix">
            <td></td>
            <td>{{ paymentLabel(mix.type) }}</td>
            <td></td>
            <td class="num" [centToEurDisplay]="mix.quantity"></td>
          </tr>
          }
          }
          }
        </tbody>
      </table>
      } @else {
      <div>Sin tickets en este periodo</div>
      }

      <div class="hr"></div>

      <div class="row"><span>Tickets</span><span>{{ closing.tickets_count }}</span></div>
      <div class="row"><span>Efectivo</span><span [centToEurDisplay]="closing.cash_sales"></span></div>
      <div class="row"><span>Tarjeta</span><span [centToEurDisplay]="closing.card_sales"></span></div>
      <div class="row"><span>Otros</span><span [centToEurDisplay]="closing.other_sales"></span></div>
      <div class="row total-row"><span>TOTAL</span><span [centToEurDisplay]="closing.total_sales"></span></div>

      <div class="hr"></div>

      <div class="row"><span>Fondo inicial</span><span [centToEurDisplay]="closing.opening_amount"></span></div>
      <div class="row"><span>Efectivo esperado</span><span [centToEurDisplay]="closing.expected_cash"></span></div>
      <div class="row">
        <span>Efectivo contado</span>
        @if(closing.counted_cash !== null){ <span [centToEurDisplay]="closing.counted_cash"></span> } @else { <span>—</span> }
      </div>
      <div class="row">
        <span>Descuadre</span>
        @if(closing.difference !== null){ <span [centToEurDisplay]="closing.difference"></span> } @else { <span>—</span> }
      </div>
      <div class="row"><span>Retirada</span><span [centToEurDisplay]="closing.cash_withdrawn"></span></div>

      @if(closing.notes){
      <div class="hr"></div>
      <div>{{ closing.notes }}</div>
      }
    </app-ticket-paper>
  </div>
  }

</div>
